module.exports = __webpack_public_path__ + "img/img_modC.698f075a.png";